/* Extracted from productpage.html and adapted for Shopify */
(function(){
    // ===== Gallery thumbnails =====
    const mainImg = document.getElementById('mainImg');
    const thumbs = Array.from(document.querySelectorAll('.thumb'));
  
    if (mainImg) {
      thumbs.forEach(btn => {
        btn.addEventListener('click', () => {
          const src = btn.getAttribute('data-src');
          const alt = btn.getAttribute('data-alt') || 'Product image';
          if (!src) return;
  
          mainImg.src = src;
          mainImg.alt = alt;
  
          thumbs.forEach(t => t.setAttribute('aria-current', 'false'));
          btn.setAttribute('aria-current', 'true');
        });
      });
    }
  
    // ===== Quantity =====
    const qtyInput = document.getElementById('qtyInput');
    const minus = document.getElementById('qtyMinus');
    const plus = document.getElementById('qtyPlus');
  
    if (qtyInput) {
      const clampQty = () => {
        let v = Number(qtyInput.value);
        if (!Number.isFinite(v) || v < 1) v = 1;
        qtyInput.value = String(Math.floor(v));
      };
  
      if (minus) {
        minus.addEventListener('click', () => {
          clampQty();
          qtyInput.value = String(Math.max(1, Number(qtyInput.value) - 1));
        });
      }
  
      if (plus) {
        plus.addEventListener('click', () => {
          clampQty();
          qtyInput.value = String(Number(qtyInput.value) + 1);
        });
      }
  
      qtyInput.addEventListener('input', clampQty);
      qtyInput.addEventListener('blur', clampQty);
    }
  
    // ===== Toast + Add to cart (demo hook) =====
    const toast = document.getElementById('toast');
    let toastTimer = null;
  
    const showToast = (msg) => {
      if (!toast) return;
      toast.textContent = msg;
      toast.classList.add('show');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => toast.classList.remove('show'), 1400);
    };
  
    /* Note regarding Add to Cart:
       In Shopify, the form submission is typically handled by the form action itself.
       If AJAX add to cart is required, we would intercept the submit here.
       For now, we will leave the standard form submission but keep the toast for sticky bar or if we prevent default.
    */
    
    // Sticky Mobile Bar
    const stickyBar = document.getElementById('stickyBar');
    const purchaseBlock = document.querySelector('.purchase');
    const stickyAdd = document.getElementById('stickyAdd');
    const mainAddToCart = document.getElementById('addToCart');
  
    if (stickyBar && purchaseBlock) {
      const onScroll = () => {
        const r = purchaseBlock.getBoundingClientRect();
        const passed = r.bottom < 0; // scrolled past
        stickyBar.classList.toggle('show', passed);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
  
      // Connect sticky add to cart to main add to cart
      if (stickyAdd && mainAddToCart) {
        stickyAdd.addEventListener('click', () => {
            mainAddToCart.click();
        });
      }
    }
  
    // ===== Size chart modal =====
    const openSize = document.getElementById('openSizeChart');
    const modal = document.getElementById('sizeModal');
    const closeSize = document.getElementById('closeSize');
    const backdrop = document.getElementById('sizeBackdrop');
  
    if (modal) {
      const openModal = () => {
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        if (closeSize) closeSize.focus();
      };
      const closeModal = () => {
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        if (openSize) openSize.focus();
      };
  
      if (openSize) openSize.addEventListener('click', openModal);
      if (closeSize) closeSize.addEventListener('click', closeModal);
      if (backdrop) backdrop.addEventListener('click', closeModal);
  
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') closeModal();
      });
    }
  })();
